import type { AuthMe } from '@respiria/shared';
import { useQuery } from '@tanstack/react-query';
import { ApiError, api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

/**
 * Current session. A 401 is a valid answer ("not logged in"), not an error to
 * retry, so it resolves to null instead of throwing.
 */
export function useAuth() {
  const query = useQuery({
    queryKey: queryKeys.auth(),
    queryFn: async (): Promise<AuthMe | null> => {
      try {
        return await api<AuthMe>('/api/auth/me');
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    retry: false,
    staleTime: 60_000,
  });

  return {
    ...query,
    auth: query.data ?? null,
    isAuthenticated: Boolean(query.data),
    needsOnboarding: query.data?.needsOnboarding ?? false,
    needsApproval: query.data?.needsApproval ?? false,
  };
}
